// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userActionCreators } from '../../actions';
import useBindActionsCreator from '../../hooks/useBindActionsCreator';
import useMergeProps from '../../hooks/useMergeProps';
import { selectUserConnected } from '../../selectors/user/userPrimary.selector';

import MenuDesktopFavoriteButton from './MenuDesktopFavoriteButton';
import selectFavoriteButtonProps from './MenuDesktopFavoriteButton.selector';

const MenuDesktopFavoriteButtonContainer = () => {
  const isConnected = useSelector(selectUserConnected);
  const selectedProps = useSelector(selectFavoriteButtonProps);

  const memoizedActions = useMemo(
    () => ({
      clearFavoritePreferences: () => userActionCreators.clearPreferences('favorites'),
    }),
    [],
  );

  const actionsProps = useBindActionsCreator(memoizedActions);

  const enhancedProps = useMergeProps({ selectedProps, actionsProps });

  return isConnected ? <MenuDesktopFavoriteButton {...enhancedProps} /> : null;
};

export default MenuDesktopFavoriteButtonContainer;
